import { render, staticRenderFns } from "./ProductIdStickerField.vue?vue&type=template&id=9789ea1c&scoped=true&"
import script from "./ProductIdStickerField.vue?vue&type=script&lang=js&"
export * from "./ProductIdStickerField.vue?vue&type=script&lang=js&"
import style0 from "./ProductIdStickerField.vue?vue&type=style&index=0&id=9789ea1c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9789ea1c",
  null
  
)

export default component.exports